const articleMapping = {
  journal: '基金會會刊',
  publication: '出版刊物',
  poster: '海報',
  film: '影片',
  cherishStory: '珍愛故事',
  form: '表單',
  news: '最新消息',
  video: '影音專區',
  gift: '贈品區管理',
  directorsBoard: '董事名單',
  workReport: '工作報告',
  financialReport: '財務報告',
  donorList: '捐款徵信錄',
  donationList: '受助清冊',
  publicReport: '公益勸募報告',
  relatedWebsites: '相關網站',
  donationMethod: '捐款方式',
  donationFAQ: '常見問題管理',
};

export default articleMapping;
